<template>
  <b-card>
    <title-name />
    <template-content />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Contract_templates/elements/Title.vue'
import TemplateContent from '@/views/Admin/Defines/Contract_templates/elements/TemplateContent.vue'

export default {
  name: 'TemplateForm',
  components: {
    TemplateContent,
    BCard,
    TitleName,
  },
}
</script>
